import { parseSocialIntent } from './social-intent';

export function startSocialAuthorization(screen: 'login' | 'register' = 'login', intent?: string | null): void {
  const destination = new URL('/api/social/v1/session/start', process.env.API);
  const parameters = new URLSearchParams(window.location.search);
  destination.searchParams.set('screen', screen);
  destination.searchParams.set('returnTo', parameters.get('returnTo') || '/');
  const validIntent = parseSocialIntent(intent ?? parameters.get('intent'));
  if (validIntent) destination.searchParams.set('intent', validIntent);
  window.location.replace(destination.toString());
}
